import React from 'react';
import { Link } from 'react-router-dom';
import './Button.css';

type ButtonProps =
  | (React.ButtonHTMLAttributes<HTMLButtonElement> & { href?: undefined; children: React.ReactNode; className?: string })
  | (React.AnchorHTMLAttributes<HTMLAnchorElement> & { href: string; children: React.ReactNode; className?: string });

const Button: React.FC<ButtonProps> = (props) => {
  const { href, children, className = '', ...rest } = props as any;
  if (href) {
    const isInternalRoute = typeof href === 'string' && href.startsWith('/');

    if (isInternalRoute) {
      return (
        <Link to={href} className={`custom-btn ${className}`}>
          {children}
        </Link>
      );
    }

    return (
      <a href={href} className={`custom-btn ${className}`} {...(rest as React.AnchorHTMLAttributes<HTMLAnchorElement>)}>
        {children}
      </a>
    );
  }
  return (
    <button className={`custom-btn ${className}`} {...(rest as React.ButtonHTMLAttributes<HTMLButtonElement>)}>
      {children}
    </button>
  );
};

export default Button;
